export const getCurrentUser = () => {
  let user = null;
  try {
    user = localStorage.getItem('gogo_current_user') != null ? JSON.parse(localStorage.getItem('gogo_current_user')) : null;
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js  : getCurrentUser -> error", error)
    user = null;
  }
  return user;
}

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem('gogo_current_user', JSON.stringify(user))
    } else {
      localStorage.removeItem('gogo_current_user')
    }
  } catch (error) {
    console.log(">>>>: src/helpers/Utils.js : setCurrentUser -> error", error)
  }
};

export const removeCurrentUser = () => {
  localStorage.removeItem('gogo_current_user');
};

export const UserRole = {
  admin: 1,           // Read-only access
  editor: 2,
  member: 3,
  electrical: 4,
  assembly: 5,
  superAdmin: 0,      // Full edit access
  PRODUCTION_ADMIN: 10,
  ELECTRICAL_ADMIN: 11,
  FIRMWARE_ADMIN: 12,
  Production: 10,     // Alias for PRODUCTION_ADMIN
  Electrical: 11,     // Alias for ELECTRICAL_ADMIN
  Firmware: 12,       // Alias for FIRMWARE_ADMIN
  Admin: 1,           // Alias for admin
  "Super Admin": 0,   // Alias for superAdmin
}

// Helper functions for role-based access control
export const canEditMetaInfo = (userRole) => {
  return userRole === UserRole.superAdmin;
}

export const canReadMetaInfo = (userRole) => {
  return userRole === UserRole.admin || userRole === UserRole.superAdmin;
}

export const getRoleName = (roleNumber) => {
  const roleNames = {
    0: 'Super Admin',
    1: 'Admin',
    2: 'Editor',
    3: 'Member',
    4: 'Electrical',
    5: 'Assembly',
    10: 'Production Admin',
    11: 'Electrical Admin',
    12: 'Firmware Admin'
  };
  return roleNames[roleNumber] || 'Unknown';
}